import startCase from 'lodash/startCase';
import {ChangeEvent, useCallback, useState} from 'react';
import {useSelector} from 'react-redux';
import {validURL} from '~/common/fabric/CreateDesign/components/EventGifting/utils';
import {selectRegistryWording} from '~/common/fabric/reducers/giftingOptions/selectors';
import {Button} from '~library/atoms/Button';
import {Input} from '~library/atoms/Input';
import {DeleteBinLineIcon} from '~library/svg/DeleteBinLineIcon';
import {link} from '~libSass/base/_exports.sass';

import './RegistryItem.sass';

type RegistryItemProps = {
  id: string;
  value: string;
  firstItem: boolean;
  hideDeleteButton: boolean;
  onDelete: (key: string) => void;
  onChange: (key: string, value: string) => void;
};

export const RegistryItem = ({
  id,
  value,
  onDelete,
  onChange,
  hideDeleteButton,
}: RegistryItemProps) => {
  const giftRegistryWording = useSelector(selectRegistryWording);
  const [typing, setTyping] = useState(false);

  const onChangeHandler = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => onChange(id, e.target.value),
    [id, onChange]
  );

  const onDeleteHandler = useCallback(() => onDelete(id), [id, onDelete]);

  return (
    <div className="new-gift-registry-item">
      <Input
        className="gift-registry__url"
        data-qa-id="registry-url"
        type="text"
        value={value}
        onChange={onChangeHandler}
        onFocus={() => setTyping(true)}
        onBlur={() => setTyping(false)}
        error={!typing && value && !validURL(value) ? 'Invalid URL' : undefined}
        placeholder={`Enter a ${startCase(giftRegistryWording)} URL`}
      />

      {!hideDeleteButton && (
        <Button
          data-qa-id="registry-delete"
          className="gift-registry__delete-button"
          variant="link"
          size="small"
          onClick={onDeleteHandler}
          icon={<DeleteBinLineIcon ratio={0.5} color={link} />}
        />
      )}
    </div>
  );
};
